import React, { FC } from 'react';
import { PageProps, graphql } from 'gatsby';
import { IGatsbyImageData } from 'gatsby-plugin-image';
import Layout from '../components/Layout';
import View from '../views/404';
import flattenMessages from '../helpers/flattenMessages';

interface ErrorDataType {
  file: {
    childJson: {
      content: {
        title: string;
        subtitle: string;
        action: string;
        action_contact: string;
        action_home: string;
        image: {
          childImageSharp: {
            gatsbyImageData: IGatsbyImageData;
          };
        };
      };
    };
  };
}

interface ContextType {
  locale: string;
}

const Page: FC<PageProps<ErrorDataType, ContextType>> = props => {
  const {
    pageContext: { locale },
    data,
  } = props;

  const messages = flattenMessages(data.file.childJson, 'home');

  return (
    <Layout locale={locale} messages={messages}>
      <View
        image={
          data.file.childJson.content.image.childImageSharp.gatsbyImageData
        }
      />
    </Layout>
  );
};

export { default as Head } from '../components/Head';

export default Page;

export const query = graphql`
  query ErrorQuery($name: String!) {
    file(relativeDirectory: { eq: "404" }, name: { eq: $name }) {
      childJson {
        content {
          title
          subtitle
          action
          action_contact
          action_home
          image {
            childImageSharp {
              gatsbyImageData
            }
          }
        }
        ...Meta
      }
    }
  }
`;
